if (!customElements.get('isha-cart-discount')) {
  customElements.define('isha-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.form?.addEventListener('submit', (event) => this.apply(event));
      this.querySelector('[data-remove-discounts]')?.addEventListener('click', () => this.update(''));
    }

    async apply(event) {
      event.preventDefault();
      const code = new FormData(this.form).get('discount')?.trim();
      if (!code) {
        this.show('Enter a discount code.');
        return;
      }
      await this.update(code);
    }

    async update(code) {
      const button = this.form?.querySelector('button');
      if (button) button.disabled = true;
      this.show(code ? 'Applying...' : 'Removing...');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        if (code) {
          const applications = cart.cart_level_discount_applications || [];
          const lineApplications = (cart.items || []).flatMap((item) => item.line_level_discount_allocations || []);
          const applied = [...applications, ...lineApplications].some((entry) => {
            const title = entry.title || entry.discount_application?.title || '';
            return title.toLowerCase() === code.toLowerCase();
          });
          if (!applied) {
            this.show('This code is not valid for the current cart.');
            if (button) button.disabled = false;
            return;
          }
        }
        if (!location.pathname.endsWith('/cart')) sessionStorage.setItem('ishaReopenCart', '1');
        location.reload();
      } catch (error) {
        this.show('The code could not be applied. Please try again.');
        if (button) button.disabled = false;
      }
    }

    show(message) {
      if (this.status) this.status.textContent = message;
    }
  });
}

window.addEventListener('load', () => {
  if (sessionStorage.getItem('ishaReopenCart') !== '1') return;
  sessionStorage.removeItem('ishaReopenCart');
  document.querySelector('.wt-cart__trigger')?.click();
});